var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50017 16.4167C6.9344 16.4167 5.40379 15.9524 4.1019 15.0825C2.80001 14.2126 1.78531 12.9762 1.18612 11.5296C0.586926 10.083 0.43015 8.49126 0.735616 6.95558C1.04108 5.4199 1.79507 4.00928 2.90224 2.90212C4.0094 1.79495 5.42002 1.04096 6.9557 0.735494C8.49138 0.430028 10.0832 0.586804 11.5297 1.186C12.9763 1.78519 14.2127 2.79989 15.0826 4.10178C15.9525 5.40367 16.4168 6.93428 16.4168 8.50004C16.4168 10.5997 15.5828 12.6133 14.0981 14.098C12.6134 15.5826 10.5998 16.4167 8.50017 16.4167ZM8.50017 14.8334C9.75278 14.8334 10.9773 14.4619 12.0188 13.766C13.0603 13.0701 13.872 12.081 14.3514 10.9237C14.8308 9.76644 14.9562 8.49302 14.7118 7.26447C14.4674 6.03593 13.8642 4.90743 12.9785 4.0217C12.0928 3.13597 10.9643 2.53278 9.73574 2.2884C8.50719 2.04403 7.23377 2.16945 6.0765 2.64881C4.91924 3.12816 3.93011 3.93992 3.23419 4.98143C2.53828 6.02294 2.16683 7.24743 2.16683 8.50004C2.16683 10.1797 2.83409 11.7907 4.02182 12.9784C5.20955 14.1661 6.82046 14.8334 8.50017 14.8334ZM7.7085 10.875H9.29183V12.4584H7.7085V10.875ZM7.7085 4.54171H9.29183V9.29171H7.7085V4.54171Z",
    fill: "#00213F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.f4d3f0d8fe44e41f8d5408d1553311db.svg";
export { ForwardRef as ReactComponent };